import * as React from 'react';
import { toast } from 'react-toastify';
import GoogleMap from './GoogleMap';
import { GetQuery } from './Shared';
import { useParams } from 'react-router-dom';
import type { ScheduleRoutes } from './models/JobScheduleInterfaces';


const AllocateMapData = () => {
    const { scheduleDate } = useParams();
    const [routes, setRoutes] = React.useState<ScheduleRoutes[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getAllocateAddresses()
    }, [scheduleDate]);

    const getAllocateAddresses = async () => {
        const apiUrl = "GetAllocatingItemAddresses?ScheduleDate=" + scheduleDate;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            let truckRoutes = result.data;
            setRoutes(truckRoutes);
            setLoading(false);
        }
    }

    let map = <GoogleMap routes={routes} />
    const renderDetails = (
        <div>
            <div className="row">
                {map}
            </div>

        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );

};

export default AllocateMapData;